export default __webpack_public_path__ + "static/media/onboardingBg.a9f0315c.png";